import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../Modal';
import styles from '../../login/LoginForm/LoginForm.module.css';
import registerPaywallFlow from '../hook';

const RegisterPaywallForm = () => {
  const [showModal, setShowModal] = useState(false);
  const [modalText, setModalText] = useState('');
  const [data, setData] = useState({
    articlecount: '',
    autoenablearticle: false,
    role: 'admin'
  });

  const handleModalText = (text) => {
    setModalText(text);
  };

  const updatePaywallSettings = registerPaywallFlow();

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowModal(true);

    const articleCount = data.articlecount;
    const autoEnableArticle = data.autoenablearticle;

    updatePaywallSettings({
      articleCount,
      autoEnableArticle,
      changeModalText: handleModalText,
      setShowModal
    });
  };

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value !== 'on' ? e.target.value : e.target.checked
    });
  };

  return (
    <form id={styles['login-form']} onSubmit={handleSubmit}>
      <p>Number of content pieces you would like to give Fewcents users free of cost</p>
      <input
        required
        type="text"
        name="articlecount"
        onChange={handleChange}
        value={data.articlecount}
        placeholder="Number of Free Articles"
      />
      <h4 className={styles['email-header']}>
        <input type="checkbox" name="autoenablearticle" onChange={handleChange} /> Auto Enable Articles for Paywall
      </h4>
      <input type="submit" value="Update" disabled={data.articlecount === ''} id={styles['login-form__submit']} />
      {showModal && <RegisterModal setShowModal={setShowModal} text={modalText} />}
    </form>
  );
};

const RegisterModal = ({ setShowModal, text }) => (
  <Modal setShowModal={setShowModal} isLogin>
    <p>{text}</p>
  </Modal>
);

RegisterModal.propTypes = {
  setShowModal: PropTypes.node.isRequired,
  text: PropTypes.node.isRequired
};

export default RegisterPaywallForm;
